@if (client.result$ | async; as result) {

    @if (result.isLoading) {
        <cll-spinner />
    }

    @if (result.error; as error) {
        <app-error-panel [error]="error" />
    }

    @if (result.value?.data; as clientData) {
        <app-header [breadcrumbs]="['Clients', getDisplayName(clientData.person)]"
                    mainHeading="{{getDisplayName(clientData.person)}}"
                    [links]="['/clients', '/clients/' + clientData.id]">
            <h4 subHeading class="header-sub-heading">Reference: {{ clientData.reference }}</h4>
            <div providerBadge>
                @if (clientData.status) {
                    <cll-badge colour="primary">Active</cll-badge>
                } @else {
                    <cll-badge colour="error">Inactive</cll-badge>
                }
            </div>
            @if (currentUser()?.permissions?.permission_name?.includes('Administrator')) {
                <div headingButton>
                    <button class="add-button"
                            [cllMenuTriggerFor]="clientMore"
                            cll-icon-button>
                        <cll-icon type="outlined">more_vert</cll-icon>
                    </button>
                    <ng-template #clientMore>
                        @if (clientData.status) {
                            <cll-menu>
                                <button cllMenuItem (click)="changeStatus(clientData, false)">
                                    <cll-icon type="outlined">toggle_off</cll-icon>
                                    Mark as inactive
                                </button>
                            </cll-menu>
                        } @else {
                            <cll-menu>
                                <button cllMenuItem (click)="changeStatus(clientData, true)">
                                    <cll-icon type="outlined">toggle_on</cll-icon>
                                    Mark as active
                                </button>
                            </cll-menu>
                        }
                    </ng-template>
                </div>

            }
        </app-header>

        <div class="client-view-container">
            @if (this.client; as clientData) {
                <div class="view-accordion">
                    <cll-collapsible-card>
                        <cll-card-header>
                            <cll-icon cllCardIcon type="outlined">person</cll-icon>
                            <cll-card-title>
                                General information
                            </cll-card-title>
                            <cll-card-subtitle>Full name, pronouns, date of birth, birth sex, nationality
                            </cll-card-subtitle>
                        </cll-card-header>
                        <app-client-details (editGeneralInformationEvent)="editGeneralInformation()"
                                            [clientData]="clientData" />
                    </cll-collapsible-card>
                    <cll-collapsible-card>
                        <cll-card-header>
                            <cll-icon cllCardIcon type="outlined">home</cll-icon>
                            <cll-card-title>
                                Contact & access details
                            </cll-card-title>
                            <cll-card-subtitle>Map, primary address, email, phone number
                            </cll-card-subtitle>
                        </cll-card-header>
                        <app-client-contact-address (editContactAddressDetailsEvent)="editContactAddressDetails()"
                                                    [clientData]="clientData" />
                    </cll-collapsible-card>
                    <cll-collapsible-card>
                        <cll-card-header>
                            <cll-icon cllCardIcon type="outlined">comments</cll-icon>
                            <cll-card-title>
                                Additional comments
                            </cll-card-title>
                            <cll-card-subtitle>Any additional comments on the client
                            </cll-card-subtitle>
                        </cll-card-header>
                        <app-client-comments (editAdditionalCommentsEvent)="editAdditionalComments()"
                                             [clientData]="clientData" />
                    </cll-collapsible-card>
                </div>
            }

            <div>
                <div class="tabs-container">
                    <cll-horizontal-tabs [appearance]="tabAppearance" [tabItems]="tabItems"
                                         [currentTabId]="currentTabId"
                                         (currentTabIdChange)="currentTabIdChange($event)" />

                    @if (this.isPackagesTabOpen) {
                        @if (this.client; as clientData) {
                            <app-client-packages-tab />
                        }
                    }

                    @if (this.isDocumentsTabOpen) {
                        @if (this.client; as clientData) {
                            <app-client-documents-tab />
                        }
                    }

                    @if (this.isAuditTabOpen) {
                        @if (this.client; as clientData) {
                            <app-client-audit-tab />
                        }
                    }
                </div>
            </div>
        </div>

    }
}
